import React from "react";
import styles from "./ActionCard.module.css";

type IconVariant = "blue" | "green" | "yellow";

interface ActionCardProps {
  icon: React.ReactNode;
  iconVariant: IconVariant;
  title: string;
  description: string;
  onClick: () => void;
  disabled?: boolean;
  onDisabledClick?: () => void;
  /** Animation entry order. Used to stagger entrance on first render. */
  index?: number;
}

function ArrowIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="M13 5l7 7-7 7" />
    </svg>
  );
}

export default function ActionCard({
  icon,
  iconVariant,
  title,
  description,
  onClick,
  disabled,
  onDisabledClick,
  index = 0,
}: ActionCardProps) {
  const handleClick = () => {
    if (disabled && onDisabledClick) {
      onDisabledClick();
    } else if (!disabled) {
      onClick();
    }
  };

  const isHardDisabled = disabled && !onDisabledClick;

  return (
    <button
      className={`${styles.card} ${styles[iconVariant]} ${isHardDisabled ? styles.disabled : ""}`}
      onClick={handleClick}
      disabled={isHardDisabled}
      type="button"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className={`${styles.iconWrap} ${styles[iconVariant]}`}>{icon}</div>
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.arrowWrap}>
        <span className={styles.arrow}>
          <ArrowIcon />
        </span>
      </div>
    </button>
  );
}
